<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    v-if="isBannnerShown"
    class="notification-banner fix-class fixed-top"
  >
    <b-alert
      v-for="(banner, index) in bannerData"
      :key="index"
      class=" custom-alert"
      show
      dismissible
      :variant="null"
      :style="{ backgroundColor: banner.banner_data.color }"
      @dismissed="bannerClosed(index)"
    >
      <div class="alert-body custom-alert notification-banner">
        <p class="notification-subject">
          <strong>
            {{ banner.subject }}
          </strong>
        </p>
        <div class="notification-content">
          <span
            v-for="(part, i) in splitContent(banner.notification_body)"
            :key="i"
          >
            <span
              v-if="part.type === 'normal-banner'"
              v-html="part.text"
            >{{ removeHtmlTags(part.text) }}</span>
            <span v-if="part.type === 'text'">{{ removeHtmlTags(part.text) }}</span>
            <a
              v-if="part.type === 'link'"
              href="javascript:void(0)"
              @click="handleClick()"
            >{{ part.text }}</a>
          </span>
        </div>

      </div>
    </b-alert>
  </div>
</template>

<script>
import { BAlert } from 'bootstrap-vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import ErrorMessage from '@core/mixins/ErrorMessage'

const bannerRepository = RepositoryFactory.get('banner')
const MerchantSelfRepository = RepositoryFactory.get('SelfRegister')

export default {
  components: {
    BAlert,
  },
  mixins: [ErrorMessage],
  data() {
    return {
      bannerData: null,
      isBannnerShown: false,
      isMerchant: -1,
      color: '',
      bannerHeight: '5.5em',
      activeTermsId: null,
      termsContent: '',
    }
  },
  // created() {
  //   this.fetchBannerData()
  // },
  mounted() {
    this.fetchBannerData()
    this.getActiveTermsAndCondition()
  },
  methods: {
    async getActiveTermsAndCondition() {
      try {
        const response = await MerchantSelfRepository.getActiveTermsAndCondition()
        const { data } = response.data
        if (data) {
          this.activeTermsId = data.id
          this.termsContent = data.content
        } else {
          this.activeTermsId = null
          this.termsContent = null
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    handleClick() {
      if (this.termsContent.startsWith('https') && this.termsContent.endsWith('.pdf')) {
        window.open(this.termsContent, '_blank')
      } else if (this.termsContent) {
        const newWindow = window.open('', '_blank')
        newWindow.document.open()
        newWindow.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>Terms & Conditions</title>
            <link
              href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/4.6.0/css/bootstrap.min.css"
              rel="stylesheet"
            />
          </head>
          <body>
            <div class="container mt-5">
              <div class="card">
                <div class="card-body px-5">
                  ${this.termsContent}
                  <div class="card mt-2 border-0 shadow-none print-button-section">
                    <div class="card-body d-flex justify-content-center">
                      <button class="print-button btn btn-outline-success" style="display: inline-block;" onclick="window.print()">Print</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <style>
              @media print {
                .print-button-section {
                  display: none; !important;
                }
                .card-body {
                  box-sizing: border-box;
                  padding: 20px !important;
                }
                .card {
                  box-sizing: border-box;
                  border: 1px solid #c7c7cd !important;
                  margin: 0 !important;
                  max-width: 100%;
                }
                body {
                  margin: 0;
                  padding: 0;
                }
                .container {
                  max-width: 100%;
                  padding: 0 15px; /* Ensure consistent padding */
                }
              }
            </style>
          </body>
          </html>
        `)
        newWindow.document.close()
      }
    },
    splitContent(content) {
      return content.split('click here').map((part, index) => {
        if (index < content.split('click here').length - 1) {
          return [{ text: part, type: 'text' }, { text: 'click here', type: 'link' }]
        }
        return [{ text: part, type: 'normal-banner' }]
      }).flat()
    },
    closeBanner() {
      // Give a slight delay before hiding the banner
      setTimeout(() => {
        this.isBannerShown = false
      }, 300)
    },
    removeHtmlTags(input) {
      const doc = new DOMParser().parseFromString(input, 'text/html')
      return doc.body.textContent || ''
    },
    async fetchBannerData() {
      try {
        const bannerDataResponse = this.$store.getters.isLoggedIn
          ? await bannerRepository.getActiveBannerAuth()
          : await bannerRepository.getActiveBannerNoAuth()
        this.bannerData = bannerDataResponse.data.data
        if (this.bannerData && this.bannerData.length > 0) {
          this.isBannnerShown = true
        } else {
          this.isBannnerShown = false
        }
      } catch (fetchError) {
        // Check if error is due to unauthenticated access
        if (fetchError.response && fetchError.response.status === 401 && this.$route.name === 'login') {
          // User is unauthenticated, fetch unauthenticated banner data
          try {
            const unauthBannerDataResponse = await bannerRepository.getActiveBannerNoAuth()
            this.bannerData = unauthBannerDataResponse.data.data
            if (this.bannerData && this.bannerData.length > 0) {
              this.isBannnerShown = true
            } else {
              this.isBannnerShown = false
            }
          } catch (error) {
            // Handle error fetching unauthenticated banner data
            this.convertAndNotifyError(error)
          }
        } else {
          // Handle other errors
          this.convertAndNotifyError(fetchError)
        }
      }
    },
    // To check if the banner is expired or not
    isExpired(date) {
      const now = new Date()
      return date < now
    },
    bannerClosed(index) {
      this.bannerData.splice(index, 1)
      if (this.bannerData.length === 0) {
        this.isBannnerShown = false
      }
    },
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/themes/bordered-layout.scss";

@media (max-width: 600px) {
  .alert-body {
    font-size: 8px;
  }
  .notification-content{
    word-wrap: break-word;
    white-space: normal;
    max-width: 90%;
  }
  .notification-content p{
    line-height: 0.75rem !important;
  }
  .notification-subject{
    word-wrap: break-word;
    white-space: normal;
    max-width: 90%;
    line-height: 0.75rem !important;
  }
}
.notification-banner {
  text-align: center;
  width: 100%;
  transition: height 0.3s ease;
  border-radius: 0px;
  align-items: center;
  justify-content: center;
  margin-bottom: 0;
  padding-bottom: 0;
  color: white;
}

.custom-alert {
  height: 60px;
  margin-bottom: 0;
  padding-bottom: 0;
  color: white;
}
.alert-body {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
:root {
  --dark-bg: #1e1e1e;
  --dark-text: #ffffff;
}
.alert.alert-dismissible .close {
  padding: 1rem;
  color: var(--dark-text)
}
.fix-class {
  position: sticky;
  top: 0;
}
</style>
